import { Box, Divider, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PieChart from "../../../components/Dashboard/PieChart";

const tabLabels = ["worker", "company", "supplier"];

function ReportPiewChart({ chartData }) {
  const { t } = useTranslation(["report", "common"]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [filterDaa, setFilterData] = useState([]);

  useEffect(() => {
    let filter = chartData.filter(
      (x) => x.userType.toLowerCase() === tabLabels[selectedTab].toLowerCase()
    );
    setFilterData(filter);
  }, [chartData]);

  const handleTabChange = (event, newValue) => {
    let filter = chartData.filter(
      (x) => x.userType.toLowerCase() === tabLabels[newValue].toLowerCase()
    );
    setFilterData(filter);
    setSelectedTab(newValue);
  };

  return (
    <Paper sx={{ borderRadius: "8px", overflow: "hidden", height: 450 }}>
      <Typography variant="h6" fontWeight={600} p={2}>
        {t("subscriptionPlans")}
      </Typography>
      <Divider />
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#1976d2",
          },
        }}
      >
        {tabLabels.map((label, index) => (
          <Tab key={index} label={t(label)} />
        ))}
      </Tabs>
      <Divider />
      <Box
        p={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 350,
        }}
      >
        {filterDaa.length === 0 ? (
          <Typography variant="body1">{t("noDataAvailable", { ns: "common" })}</Typography>
        ) : (
          <PieChart
            key={selectedTab}
            chartData={filterDaa}
            // data={getChartDataForTab(selectedTab)}
          />
        )}
      </Box>
    </Paper>
  );
}

function getChartDataForTab(tabIndex) {
  const data = [
    { label: "Worker", value: 40 },
    { label: "Company", value: 30 },
    { label: "Supplier", value: 20 },
    { label: "Education", value: 10 },
  ];
  return data[tabIndex];
}

export default ReportPiewChart;
